export const SkillTypes = {
    Mastery: "Mastery",
    NonAssessed: "NonAssessed",
    Percentage: "Percentage"
}

export const getSkillTypeName = (skillTypeNumber) => {
    switch( skillTypeNumber )
    {
        case "0":
        {
            return "NonAssessed";
        }
        case "1":
        {
            return "Mastery";
        }
        case "2":
        {
            return "Percentage";
        }
        default:
        {
            return "Unknown Skill Type";
        }
    }
}



// WEBPACK FOOTER //
// ./src/constants/skillTypes.js